export interface CostManagement {
  employee_id: string;
  cost_per_hour: number;
  cost_id?: string;
}

export interface CostManagementDetail {
  perHour_cost_id: string;
  customer_id: string;
  user_id: string;
  cost_perHour: string;
  createdby: string;
  createdAt: string;
  modifiedAt: string;
  user_name: string;
  user_lastname: string;
  created_by_name: string;
  created_by_lastname: string;
  srNo?: number;
}
